"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RRA_ALERTS_BOX = exports.RRA_ALERT = exports.ALERT_TYPE__WARNING = exports.ALERT_TYPE__SUCCESS = exports.ALERT_TYPE__INFO = exports.ALERT_TYPE__ERROR = void 0;
var RRA_ALERTS_BOX = exports.RRA_ALERTS_BOX = 'RRAAlertsBox';
var RRA_ALERT = exports.RRA_ALERT = 'RRAAlert';
var ALERT_TYPE__ERROR = exports.ALERT_TYPE__ERROR = 'ALERT_TYPE__ERROR';
var ALERT_TYPE__SUCCESS = exports.ALERT_TYPE__SUCCESS = 'ALERT_TYPE__SUCCESS';
var ALERT_TYPE__INFO = exports.ALERT_TYPE__INFO = 'ALERT_TYPE__INFO';
var ALERT_TYPE__WARNING = exports.ALERT_TYPE__WARNING = 'ALERT_TYPE__WARNING';